import { IImageDataInfo } from 'interface/data/image/info.js';
import { handleGet, handleGetBlob, handlePost } from './common';

class ImageService {
  async getClientImageData(name, forceNew) {
    return await handleGetBlob('/client/images/download', {
      name,
      ...(forceNew ? { nocache: new Date().getTime() } : {}),
    });
  }

  async getGalleryImageData(name) {
    return await handleGetBlob('/file-transfer/download', {
      name,
    });
  }

  async getImagesInfo(): Promise<IImageDataInfo[]> {
    return await handleGet('/client/images');
  }

  async getGalleryImagesInfo(numOfItems, listOfNames) {
    return await handlePost('/file-transfer/images', {
      numOfItems,
      listOfNames,
    });
  }
}

export default new ImageService();
